export default __webpack_public_path__ + "static/Steve-73d75f1d4d7706330c90ef24134103b2581d5b4818db3eee12e549c9ca030638.svg";